var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sub-item-view',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(_){return [_vm._t("default",null,null,_)]}}],null,true)},'sub-item-view',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }